import mapBurstToNumber from '../../components/BudgetSplitSection/mapBurstToNumber';
import { DURATION_SECONDS } from '../../constants';

const getRatio = (
  durationLoadingSheet: Array<Array<any>>,
  duration: DURATION_SECONDS
): number => {
  const durationNumber = mapBurstToNumber(duration);
  let ratio = 1;

  durationLoadingSheet.forEach((row) => {
    if (row[0] === durationNumber) {
      ratio = row[1];
    }
  });

  return ratio;
};

export default getRatio;
